import { Empty } from "components/Empty";
import FilterWithUnits from "components/FilterWithUnits";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";
import { mq, device } from "lib/media-query";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

const format = {
    unit: "km per liter",
    divideBy: 1000,
    reversed: true,
    decimals: 1
};

export const VerbruikFilter = ({ condensed }) => {
    const filterOptions = useFilter("verbruik");
    const [value, , onChange] = useField("gecombineerdeVerbruiken");

    const options = filterOptions.map((o) => ({ id: o }));

    return (
        <Grid condensed={condensed}>
            <FilterWithUnits
                filterId="filter-verbruik"
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                datalayerKey="verbruik"
                helpText="Minimaal"
                data={options}
                format={format}
            />
            <Empty />
        </Grid>
    );
};
